import { useState } from "react";

import { useGetGreenscreensAuthTokenMutation } from "../api/greenscreens/getGreenscreensAuthToken";

export function useGreenscreensAuth(): {
  token: string | null;
  error: Error | null;
  isLoading: boolean;
  authenticate: () => Promise<void>;
} {
  const [token, setToken] = useState<string | null>(null);
  const [error, setError] = useState<Error | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const [getGreenscreensAuthToken] = useGetGreenscreensAuthTokenMutation();

  async function authenticate() {
    setIsLoading(true);
    setError(null);

    try {
      const response = await getGreenscreensAuthToken().unwrap();

      const token = response.access_token;
      setToken(token);
    } catch (err) {
      setError(err as Error);
    } finally {
      setIsLoading(false);
    }
  }

  return { token, error, isLoading, authenticate };
}
